// /*Package Imports*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
import { useSelector } from "react-redux";

const ResetPassword = (props) => {
  const enteredEmail = useSelector((state) => state.auth.email);
  const [resetEmail, setResetEmail] = useState("");
  const currentColorMode = useSelector ((state)=> state.theme.currentColorMode); /*BackO_324 */

  /*Need to implement send the reset password link email to member*/
  // const changePassword = () => {
  //   if (resetPassword) {
  //     Toastr({
  //       position: "top-center",
  //       type: "success",
  //       message: `Please check your email for your new information. This may take a few minutes.`,
  //     });
  //   }
  //   setResetPassword(!resetPassword);
  // };

  useEffect(() => {
    if (enteredEmail === undefined && localStorage.getItem("rememberMe") === "true") {
      setResetEmail(localStorage.getItem("user"));
    } else {
      setResetEmail(enteredEmail);
    }
  }, [enteredEmail]);

  return (
    <React.Fragment>
      <div style={{color: currentColorMode.color, textTransform:"uppercase", fontWeight:"500"}} /*BackO_324 */>
        <h1 className="text-center">Forgot your password?</h1>
        <br/> 
        <p className="lead">Enter your email to receive a link to reset your password.</p>
        <br/>
      </div>

      <Card style={{color: currentColorMode.color, backgroundColor: currentColorMode.backgroundColor, textTransform:"uppercase", fontWeight:"500"}}/*BackO_324 */>
        <CardBody>
          <div className="m-sm-4">
            <Form>
              <FormGroup>
                <Label>Email</Label>
                <Input bsSize="lg" type="email" name="email" placeholder="Enter your email" value={resetEmail} />
              </FormGroup>
              <div className="text-center mt-3">
                <Link to="/">
                  <Button className="mr-2" color="primary" size="lg" onClick={props.onClick}>
                    Reset password
                  </Button>
                </Link>
                <Link to="/">
                  <Button
                    color="secondary"
                    size="lg"
                    onClick={() => {
                      window.location.pathname = "/";
                    }}
                  >
                    Return to Sign In
                  </Button>
                </Link>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ResetPassword;

// /*Package Imports*/
// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import { Button, Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
// // import { useSelector } from "react-redux";
// // import { usePostSendResetPasswordLinkMutation } from "../../../data/redux/store/backofficeApi";

// // const ResetPassword = (props) => {
// //   const enteredEmail = useSelector((state) => state.auth.email);
// //   const currentColorMode = useSelector((state) => state.theme.currentColorMode); /*BackO_324*/

// //   const [resetEmail, setResetEmail] = useState("");
// //   const [message, setMessage] = useState("");
// //   const [isError, setIsError] = useState(false);

// //   const [sendResetPasswordLink, { isLoading }] = usePostSendResetPasswordLinkMutation();

// //   useEffect(() => {
// //     if (enteredEmail === undefined && localStorage.getItem("rememberMe") === "true") {
// //       setResetEmail(localStorage.getItem("user") || "");
// //     } else {
// //       setResetEmail(enteredEmail || "");
// //     }
// //   }, [enteredEmail]);

// //   const handleResetPassword = async (e) => {
// //     e.preventDefault();

// //     if (!resetEmail) {
// //       setIsError(true);
// //       setMessage("Please enter your email address.");
// //       return;
// //     }

// //     try {
// //       setMessage("");
// //       setIsError(false);

// //       await sendResetPasswordLink({
// //         body: {
// //           email: resetEmail,
// //         },
// //       }).unwrap();

// //       setIsError(false);
// //       setMessage("If this email exists in our system, a password reset link will be sent shortly.");

// //       if (props.onClick) {
// //         props.onClick();
// //       }
// //     } catch (error) {
// //       console.error(error);

// //       setIsError(true);
// //       setMessage("Unable to send password reset link. Please try again later.");
// //     }
// //   };

// //   return (
// //     <React.Fragment>
// //       <div
// //         style={{
// //           color: currentColorMode.color,
// //           textTransform: "uppercase",
// //           fontWeight: "500",
// //         }}
// //         /*BackO_324*/
// //       >
// //         <h1 className="text-center">Forgot your password?</h1>
// //         <br />
// //         <p className="lead text-center">
// //           Enter your email to receive a link to reset your password.
// //         </p>
// //         <br />
// //       </div>

// //       <Card
// //         style={{
// //           color: currentColorMode.color,
// //           backgroundColor: currentColorMode.backgroundColor,
// //           textTransform: "uppercase",
// //           fontWeight: "500",
// //         }}
// //         /*BackO_324*/
// //       >
// //         <CardBody>
// //           <div className="m-sm-4">
// //             <Form onSubmit={handleResetPassword}>
// //               <FormGroup>
// //                 <Label>Email</Label>
// //                 <Input
// //                   bsSize="lg"
// //                   type="email"
// //                   name="email"
// //                   placeholder="Enter your email"
// //                   value={resetEmail}
// //                   onChange={(e) => setResetEmail(e.target.value)}
// //                 />
// //               </FormGroup>

// //               {message && (
// //                 <div className="text-center my-3">
// //                   <p
// //                     style={{
// //                       color: isError ? "red" : currentColorMode.color,
// //                       fontSize: isError ? "1.2rem" : "1rem",
// //                       fontWeight: isError ? "800" : "600",
// //                       marginBottom: 0,
// //                     }}
// //                   >
// //                     {message}
// //                   </p>
// //                 </div>
// //               )}

// //               <div className="text-center mt-3">
// //                 <Button
// //                   className="mr-2"
// //                   color="primary"
// //                   size="lg"
// //                   type="submit"
// //                   disabled={isLoading}
// //                 >
// //                   {isLoading ? "Sending..." : "Reset Password"}
// //                 </Button>

// //                 <Link to="/">
// //                   <Button color="secondary" size="lg" type="button">
// //                     Return to Sign In
// //                   </Button>
// //                 </Link>
// //               </div>
// //             </Form>
// //           </div>
// //         </CardBody>
// //       </Card>
// //     </React.Fragment>
// //   );
// // };

// // export default ResetPassword;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Button, Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";
// import { useSelector } from "react-redux";
// import { usePostSendResetPasswordLinkMutation } from "../../../data/redux/store/backofficeApi";

// const ResetPassword = () => {
//   const enteredEmail = useSelector((state) => state.auth.email);

//   const currentColorMode = useSelector(
//     (state) => state.theme.currentColorMode
//   ); /*BackO_324*/

//   const [resetEmail, setResetEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [isError, setIsError] = useState(false);

//   const [sendResetPasswordLink, { isLoading }] =
//     usePostSendResetPasswordLinkMutation();

//   useEffect(() => {
//     if (
//       enteredEmail === undefined &&
//       localStorage.getItem("rememberMe") === "true"
//     ) {
//       setResetEmail(localStorage.getItem("user") || "");
//     } else {
//       setResetEmail(enteredEmail || "");
//     }
//   }, [enteredEmail]);

//   const handleResetPassword = async (e) => {
//     e.preventDefault();

//     if (!resetEmail) {
//       setIsError(true);
//       setMessage("Please enter your email address.");
//       return;
//     }

//     try {
//       setMessage("");
//       setIsError(false);

//       await sendResetPasswordLink({
//         body: {
//           Email: resetEmail,
//         },
//       }).unwrap();

//       setIsError(false);

//       setMessage(
//         "If this email exists in our system, a password reset link will be sent shortly."
//       );
//     } catch (error) {
//       console.error(error);

//       setIsError(true);

//       setMessage(
//         "Unable to send password reset link. Please try again later."
//       );
//     }
//   };

//   return (
//     <React.Fragment>
//       <div
//         style={{
//           color: currentColorMode.color,
//           textTransform: "uppercase",
//           fontWeight: "500",
//         }}
//       >
//         <h1 className="text-center">Forgot your password?</h1>

//         <br />

//         <p className="lead text-center">
//           Enter your email to receive a link to reset your password.
//         </p>

//         <br />
//       </div>

//       <Card
//         style={{
//           color: currentColorMode.color,
//           backgroundColor: currentColorMode.backgroundColor,
//           textTransform: "uppercase",
//           fontWeight: "500",
//         }}
//       >
//         <CardBody>
//           <div className="m-sm-4">
//             <Form onSubmit={handleResetPassword}>
//               <FormGroup>
//                 <Label>Email</Label>

//                 <Input
//                   bsSize="lg"
//                   type="email"
//                   name="email"
//                   placeholder="Enter your email"
//                   value={resetEmail}
//                   onChange={(e) => setResetEmail(e.target.value)}
//                 />
//               </FormGroup>

//               {message && (
//                 <div className="text-center my-3">
//                   <p
//                     style={{
//                       color: isError ? "red" : currentColorMode.color,
//                       fontSize: isError ? "1.2rem" : "1rem",
//                       fontWeight: isError ? "800" : "600",
//                       marginBottom: 0,
//                     }}
//                   >
//                     {message}
//                   </p>
//                 </div>
//               )}

//               <div className="text-center mt-3">
//                 <Button
//                   className="mr-2"
//                   color="primary"
//                   size="lg"
//                   type="submit"
//                   disabled={isLoading}
//                 >
//                   {isLoading ? "Sending..." : "Reset Password"}
//                 </Button>

//                 <Link to="/">
//                   <Button
//                     color="secondary"
//                     size="lg"
//                     type="button"
//                   >
//                     Return to Sign In
//                   </Button>
//                 </Link>
//               </div>
//             </Form>
//           </div>
//         </CardBody>
//       </Card>
//     </React.Fragment>
//   );
// };

// export default ResetPassword;
